module.exports = __webpack_public_path__ + "img/newCand-assessment-icon.da61b3a8.svg";